<template>
  <div>
    <app-nav></app-nav>
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-6">
          <h3> Fiche de {{titulaireById.prenom}} {{titulaireById.nom}}</h3>
        </div>
      </div>         
      <div class="row">
        <div class="col-xs-1 col-sm-1">
        </div>
        <div class="col-xs-12 col-sm-8">
          <p  class="text-left">
            <b> SEL: {{titulaireById.sel}}</b>
          </p>
          <p  class="text-left">
            <b> N° de SEL: {{titulaireById.numsel}}</b>
          </p>
          <p  class="text-left">
            <b> Nom: {{ titulaireById.nom}} </b>
          </p>
          <p  class="text-left">
            <b> Prenom: {{ titulaireById.prenom}}</b>
          </p>
          <p >
            <img :src="photo_link"  width="200" height=auto >
          </p>   
          <p  class="text-left">
            <b> Ordre: {{ titulaireById.ordre}} </b>
          </p>
          <p  class="text-left">
            <b> Adeli: {{ titulaireById.adeli}} </b>
          </p>
          <p class="text-left">
            <b> RPPS: {{titulaireById.rpps}} </b>
          </p>
          <p  class="text-left">
            <b> Retraité ?: {{titulaireById.retraite ? " oui" : " non"}}</b>
          </p>
          <router-link to="/titulaires" class="">Retour vers la liste</router-link>
          <br>
          <router-link :to="{name: 'TitulairesEdit' , params: { id: titulaireById.id }}"> Editer.</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppNav from './AppNav'
import { TITULAIRE_BY_ID_QUERY } from '../constants/graphql'
export default {
  name: 'titulaire',
  components: {
      AppNav
  },
  data () {
    return {
      titulaireById: {}
    }
  },
  apollo: {
    titulaireById: {
      query: TITULAIRE_BY_ID_QUERY,
      variables() {
        var id = parseInt(this.$route.params.id,10)
        return{
            id
        }
      }
    }
  },
  computed: {
    photo_link: function() {
      if (this.titulaireById.photo) {
          return 'uploads/' + this.titulaireById.photo
      } else {
          return '/static/poppy.jpg'
      }
    }
  }
}
</script>
<style scoped>
body {
    padding-top: 3.5rem;
}

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.medecins-form{
    padding-bottom: 60px;
}
</style>




// WEBPACK FOOTER //
// titulaire.vue?dae91f2a